import React, { useCallback, useEffect, useMemo, useState } from 'react';

import sizes from 'utils/screenSizes';

import { FilterCardapio } from './FilterCardapio';
import { IFilterCardapio } from './interfaces';

import { useCardapioContext } from 'hooks/Cardapio';

export const Container: React.FC<IFilterCardapio> = ({
  id,
  hideFilterCardapio,
  inputSelectedMobile,
  onPressAnyCategoryFilter,
  ...rest
}) => {
  const { category, handleSelectCategory, selectedCategoryId } =
    useCardapioContext();

  const [inputSelected, setInputSelected] = useState(false);
  const sizeScreen = useMemo(() => {
    if (window.screen.width > parseInt(sizes.notebook, 10)) {
      return 'desktop';
    }
    return 'mobile';
  }, []);

  const handleClickInput = (statusSelected: boolean) => {
    if (statusSelected) return setInputSelected(statusSelected);
  };

  const handlePressCategory = (
    idCategory: number,
    positionCategoryScroll: number,
  ) => {
    // handleSelectCategory(idCategory);
    onPressAnyCategoryFilter(positionCategoryScroll);
  };

  useEffect(() => {
    setInputSelected(false);
  }, [hideFilterCardapio]);

  return (
    <>
      <FilterCardapio
        {...rest}
        filtersCategory={category}
        sizeWidth={sizeScreen}
        id={`filterCardapio@${id}`}
        data-testid={`filterCardapio@${id}`}
        handleClickInput={handleClickInput}
        inputSelected={inputSelected || inputSelectedMobile}
        inputSelectedMobile={inputSelectedMobile}
        hideFilterCardapio={hideFilterCardapio}
        handlePressCategory={handlePressCategory}
        selectedCategoryId={selectedCategoryId}
      />
    </>
  );
};
